/*
*  authorization block connection
*/

import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import Twig from 'twig'
import { Modal, Popover } from 'bootstrap'
import serializer from 'form-serializer'
import {getElement} from "bootstrap/js/src/util";

export default class extends Controller {
    static targets = [ "passwordNew", "passwordNewRepeat"]

    myModal

    initialize() {
        super.initialize();
     /*   Twig.twig({
            id: "authorization", //controller name
            href: "/twig/authorization.twig",//loadable twig
            async: false
        })*/

    }

    //show/hide password
    showPass(){
        let $password = $('#show_hide_password input');
        let $inputType = $password.attr("type");
        let $passIcon = $('#show_hide_password i');
            if ($inputType === "text") {
                $password.attr('type', 'password');
                $passIcon.addClass("bx-hide");
                $passIcon.removeClass("bx-show");
            } else if ($inputType === "password") {
                $password.attr('type', 'text');
                $passIcon.removeClass("bx-hide");
                $passIcon.addClass("bx-show");
            }
    }


    header(){
        let token = sessionStorage.getItem('token');
        if (token !== null ){
            this.WhoIs = api.WhoIs();
        }

        //we turn to twig, indicate which controller to use, inside we transfer the data
        let nameVar = Twig.twig({ref: "template"}).render({
            userAuth: this.WhoIs
        });
        //specify the block and display the contents of the twig in it
        $('#template__header').html(nameVar);
        /*document.getElementById('headerContentTitle').innerHTML += 'Extra stuff';*/
    }


    /* !!!!!!!!!!! FOR USER-DOCTOR SECTION !!!!!!!!!!!! */
    //go to the list pf patients for doctor
    showDatabasePage(){
        this.header();
        $('#headerContentTitle').html('Список пациентов');
        $('#authorization').remove();
 /*       $('#database').remove();
        $('#my-schedule').remove();
        $('#form-creation').remove();
        $('#userdoc').remove();*/
        $('.xdsoft_datetimepicker').remove();
        $('#template__header').after('' +
            '<div class="d-none d-sm-flex align-items-center title-page__box" id="titlePageBox">' +
               /* '<h1 class="title-page">Список пациентов</h1>' +*/
                '<div class="ms-auto" data-controller="database">' +
                    '<button type="button" class="btn btn-light btnIcon" data-action="click->database#showMySchedule"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> Расписание</button>' +
                    '<button type="button" class="btn btn-light" data-action="click->database#addNewForm">Заполнить новую форму</button>' +
                '</div>' +
            '</div>' +
            '<div class="container-fluid database__main" id="database" data-controller="database"></div>');
    }
    /* !!!!!!!!!!! end FOR USER-DOCTOR SECTION !!!!!!!!!!!! */

    //go to the base for the manager
    showManagerbasePage(){
        this.header();
        $('#authorization').remove();
        $('.xdsoft_datetimepicker').remove();
        $('#headerContentTitle').html('Список клиентов');
        $('#template__header').after('' +
            '<div class="d-none d-sm-flex align-items-center title-page__box" id="titlePageBox">' +
                /*'<h1 class="title-page"></h1>' +*/
                '<div class="ms-auto" data-controller="managerbase">' +
                '<button type="button" class="btn btn-light btnIcon" data-action="click->managerbase#showDoctorSchedule"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> Расписание врачей </button>' +
                    '<button type="button" class="btn btn-light btnIcon" data-action="click->managerbase#addNewClient"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg> Добавить клиента</button>' +
                '</div>' +
            '</div>' +
            '<div class="container-fluid database__main" id="managerbase" data-controller="managerbase"></div>');

    }

    //go to the base for sheduler
    showOrderbasePage(){
        this.header();
        $('#authorization').remove();
        $('.xdsoft_datetimepicker').remove();
        $('#headerContentTitle').html('Расписание врачей');
        $('#template__header').after('' +
            '<div class="d-none d-sm-flex align-items-center title-page__box" id="titlePageBox">' +
           /* '<h1 class="title-page">Расписание врачей</h1>' +*/
            '<div class="ms-auto" data-controller="orderbase">' +
           /* '<button type="button" class="btn btn-light btnIcon" data-action="click->orderbase#addNewClient"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg> Добавить клиента</button>' +*/
            '</div>' +
            '</div>' +
            '<div class="container-fluid database__main" id="orderbase" data-controller="orderbase"></div>');

    }


    //show new password
    showPassNew() {
        let showpass = '#passNew';
        if ($(showpass).attr('type') === 'password'){
            $(showpass).attr('type', 'text');
        } else {
            $(showpass).attr('type', 'password');
        }
        return false;
    }

    //show Repeat password
    showPassAdd() {
        let showpassadd = '#passNewRepeat';
        if ($(showpassadd).attr('type') === 'password'){
            $(showpassadd).attr('type', 'text');
        } else {
            $(showpassadd).attr('type', 'password');
        }
        return false;
    }

    //change password
   async changePass(){
        console.debug(this.passwordNewTarget.value);
        console.debug(this.passwordNewRepeatTarget.value);

        try{
            let result = await api.setPass($('#inputEmailAddress').val(), this.passwordNewTarget.value);
            $('#inputChoosePassword').val(this.passwordNewTarget.value);

        }  catch (error) {
            console.debug(error)
        }
    }

    //log in authorization
   async enter(){
        let form = $("#authorization__form")[0];
        if (form.checkValidity()) {
            let json = $(form).serializeObject();
            try {
                let login = await api.Login(json.login, json.pass);
                sessionStorage.setItem('token', login.token);
                sessionStorage.setItem('userId', login.user_id);

                let result = api.WhoIs();
                global.WhoIs = result;
                if (global.WhoIs.Type === 'consul' ||
                    global.WhoIs.Type === 'stylist' ||
                    global.WhoIs.Type === 'master') {
                    sessionStorage.clear();
                    $('#authorization__form').prepend('<div class="alert alert-warning">У вас нет прав. Обратитесь к администратору </div>');
                } else if(global.WhoIs.Type === 'doctor' || global.WhoIs.Type === 'child_doctor'){
                    this.showDatabasePage();
                }
                else if(global.WhoIs.Type === 'manager' || global.WhoIs.Type === 'office') {
                    this.showManagerbasePage();
                }
                else if(global.WhoIs.Type === 'scheduler') {
                    this.showOrderbasePage();
                }

            } catch (error) {
                console.debug(error);
                $('#authorization__form').prepend('<div class="alert alert-warning">Неправильный логин или пароль. </div>');
                console.debug(error.responseText);
                if (error.responseText === 'should change password') {
                    console.debug('ERROR');
                    if (this.myModal === undefined){
                        this.myModal = new Modal(document.getElementById('changePass'));
                    }
                    this.myModal.show();
                }
            }
        }
        form.classList.add('was-validated');
    }

    connect() {
      let token = sessionStorage.getItem('token');
      if (token !== null ) {
            let result = api.WhoIs();
            global.WhoIs = result;

          //when refreshing the page, the database opens by default
          if (result.Type === 'consul' ||
              result.Type === 'stylist' ||
              result.Type === 'master') {
              sessionStorage.clear();
              $('#authorization__form').prepend('<div class="alert alert-warning">У вас нет прав. Обратитесь к администратору </div>');
          } else if(result.Type === 'doctor' || result.Type === 'child_doctor'){
              this.showDatabasePage();
          }
          else if(global.WhoIs.Type === 'manager' || global.WhoIs.Type === 'office') {
              this.showManagerbasePage();
          }
          else if(global.WhoIs.Type === 'scheduler') {
              this.showOrderbasePage();
          }

      } else {
          //we turn to twig, indicate which controller to use, inside we transfer the data
          let nameVar = Twig.twig({ref: "authorization"}).render({

          });
          //specify the block and display the contents of the twig in it
          $('#authorization').html(nameVar)
      }
    }
}